import * as React from "react";

interface EllipsisVerticalIconProps {
    className?: string;
    onClick?: () => void;
    id?: string;
}

export class EllipsisVerticalIcon extends React.Component<EllipsisVerticalIconProps> {
    render(){
        return (
          <div {...this.props} id={this.props.id}>
            <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 128 512">
                <path d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"/>
            </svg>
           </div>
        );
    }
}
